import {type IconDefinition} from '@fortawesome/fontawesome-svg-core'
export default {
    'calendar': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faCalendar" */
        '@fortawesome/free-regular-svg-icons/faCalendar'
    ),
    'check-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSquareCheck" */
        '@fortawesome/free-regular-svg-icons/faSquareCheck'
    ),
    'circle-xmark': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faXmarkCircle" */
        '@fortawesome/free-regular-svg-icons/faXmarkCircle'
    ),
    'comment-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faMessage" */
        '@fortawesome/free-regular-svg-icons/faMessage'
    ),
    'comments': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faComments" */
        '@fortawesome/free-regular-svg-icons/faComments'
    ),
    'face-meh': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faMeh" */
        '@fortawesome/free-regular-svg-icons/faMeh'
    ),
    'face-meh-blank': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faMehBlank" */
        '@fortawesome/free-regular-svg-icons/faMehBlank'
    ),
    'frown-open': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faFrownOpen" */
        '@fortawesome/free-regular-svg-icons/faFrownOpen'
    ),
    'grin-beam-sweat': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faGrinBeamSweat" */
        '@fortawesome/free-regular-svg-icons/faGrinBeamSweat'
    ),
    'hand-back-fist': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faHandRock" */
        '@fortawesome/free-regular-svg-icons/faHandRock'
    ),
    'hospital-alt': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faHospitalWide" */
        '@fortawesome/free-regular-svg-icons/faHospitalWide'
    ),
    'laugh-beam': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faLaughBeam" */
        '@fortawesome/free-regular-svg-icons/faLaughBeam'
    ),
    'laugh-wink': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faLaughWink" */
        '@fortawesome/free-regular-svg-icons/faLaughWink'
    ),
    'meh-rolling-eyes': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faMehRollingEyes" */
        '@fortawesome/free-regular-svg-icons/faMehRollingEyes'
    ),
    'minus-square': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSquareMinus" */
        '@fortawesome/free-regular-svg-icons/faSquareMinus'
    ),
    'registered': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faRegistered" */
        '@fortawesome/free-regular-svg-icons/faRegistered'
    ),
    'sad-tear': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faSadTear" */
        '@fortawesome/free-regular-svg-icons/faSadTear'
    ),
    'window-close': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faWindowClose" */
        '@fortawesome/free-regular-svg-icons/faWindowClose'
    ),
    'xmark-circle': ()=>import(
        /* webpackChunkName: "fontawesome/fa-svg-regular-faXmarkCircle" */
        '@fortawesome/free-regular-svg-icons/faXmarkCircle'
    ),
} as Record<string, ()=>Promise<{ definition: IconDefinition }>>